import React from 'react';
import CreditNoteForm from './CreditNoteForm';

const NewCreditNotePage = () => {
    return <CreditNoteForm formType="create" currentId={null} />;
};

export default NewCreditNotePage;